// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__1Ls_v","card":"styles_card__14LJf","header":"styles_header__Jcso9"};